export default "__VITE_ASSET__NFe728GW__"